import { render } from "./IconMercadoPago.vue?vue&type=template&id=6f2a98d3"
import script from "./IconMercadoPago.vue?vue&type=script&lang=js"
export * from "./IconMercadoPago.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__